module.exports = __webpack_public_path__ + "static/media/success.de1a5f08.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Forms/success.md
// module id = 205
// module chunks = 0